<!-- Services section -->
<div class="vehicle-history-dialog-body">
  <!-- Vehicle owner tree -->
  <div class="vehicle-history-owner-wrapper">
    <div class="vehicle-history-owner-info d-none">
      <span> {{ vehicleHistory?.ownerName || 'Untitled' }} {{ vehicleIndex === 0 ? '(Current)' : '' }} </span>
    </div>

    <!-- Accordian -->
    <p-accordion
      styleClass="vehicle-history-accordion {{ vehicleHistory?.historyOrder ? 'imported-ro-vehicle' : '' }} estimate-accordion reverse-chevron-icon"
      expandIcon="pi pi-fw pi-chevron-right" collapseIcon="pi pi-fw pi-chevron-down" [multiple]="true">
      <p-accordionTab [selected]="isSearchEntered">
        <!-- Follow-up header -->
        <p-header>
          <div class="accordion-trigger" [ngClass]="{ 'vehicle-history-trigger': vehicleHistory?.historyOrder }">
            <div class="vehicle-history-accordian-header">
              <div class="vehicle-accordian-left">
                <div class="vehicle-panel">
                  <div class="vehicle-accordian-icon">
                    <i class="far fa-file-alt"></i>
                  </div>

                  <div class="vehicle-accordian-content">
                    <p [innerHTML]="vehicleHistory?.title | highlight : searchQuery"
                      [ngClass]="{ 'hover-underline pointer vehicle-accordian-text-green': vehicleHistory?.historyOrder }"
                      (click)="openImportOrder(vehicleHistory, $event)"
                      class="mb-0 one-line-elipsis vehicle-accordian-text mt-0" tooltipPosition="top"
                      [pTooltip]="vehicleHistory?.title"></p>

                    <p class="mb-0">
                      <i class="far fa-calendar-day"></i>
                      Created: {{ vehicleHistory?.createdAt | date : 'MMM d, y' }}
                      <span *ngIf="vehicleHistory?.historyOrder" class="m-0 ml-2 import-ro-tag font-gray-65"> Imported
                      </span>
                    </p>
                  </div>
                </div>

                <div class="location-pill" *ngIf="isMultiLocationEnabled && vehicleHistory?.shopId">
                  <span class="location-bg"
                    [ngStyle]="{ backgroundColor: shopsMap[vehicleHistory?.shopId]?.shopColor }"></span>

                  <p class="location-name" [ngStyle]="{ color: shopsMap[vehicleHistory?.shopId]?.shopColor }">
                    <i class="fal fa-store-alt"></i>
                    {{ shopsMap[vehicleHistory?.shopId]?.shopName }}
                  </p>
                </div>
              </div>

              <div class="vehicle-accordian-right">
                <div class="vehicle-ro-status"
                  [ngClass]="{ 'bg-font-orange': vehicleHistory?.orderStatus !== 'invoice' }">
                  <span class="capitalize" *ngIf="vehicleHistory?.orderStatus !== 'invoice'">
                    {{ vehicleHistory?.orderStatus }}
                  </span>

                  <span class="capitalize" *ngIf="vehicleHistory?.orderStatus === 'invoice'">
                    {{ vehicleHistory?.orderStatus }}
                  </span>
                </div>

                <div class="vehicle-ro-miles">
                  <span class="ro-miles-count" *ngIf="vehicleHistory?.vehicleMileage?.reading">
                    {{ vehicleHistory?.vehicleMileage?.reading || 0 }} {{
                    vehicleHistory?.vehicleMileage?.mileageMeasuringUnit === 'mi' ? 'miles' : 'km' }}
                  </span>

                  <span class="ro-miles-count pr-4" *ngIf="!vehicleHistory?.vehicleMileage?.reading"> - </span>
                  <!-- <span class="ro-mileage-scale">{{vehicleHistory?.vehicleMileage?.mileageMeasuringUnit === 'mi'? 'Miles': 'km' }}</span> -->
                  <span class="ro-mileage-scale">Mileage</span>
                </div>

                <div class="vehicle-ro-amount">
                  <span class="ro-amount">
                    {{ vehicleHistory?.total?.grand | currency : usd }}
                  </span>

                  <span class="ro-created-date" *ngIf="vehicleHistory?.orderStatus === 'invoice'"> Invoiced: {{
                    vehicleHistory?.invoiceDate | date : 'MMM d, y' }} </span>

                  <span class="ro-created-date" *ngIf="vehicleHistory?.orderStatus !== 'invoice'"> Estimated </span>
                </div>

                <div class="vehicle-ro-paid-amount">
                  <span class="ro-paid-amount" *ngIf="vehicleHistory?.orderStatus !== 'invoice'">N/A</span>

                  <span class="ro-paid-amount" *ngIf="vehicleHistory?.orderStatus === 'invoice'">
                    {{ vehicleHistory?.isPaidFull ? (vehicleHistory?.total?.paid | currency : usd) :
                    (vehicleHistory?.total?.unpaid | currency : usd )}}
                  </span>

                  <span class="ro-created-date" *ngIf="vehicleHistory?.orderStatus === 'invoice'">
                    {{ vehicleHistory?.isPaidFull ? 'Paid' : 'Unpaid' }}:
                    <ng-container>
                      <ng-container *ngIf="vehicleHistory?.displayPaidDates;">
                        {{ vehicleHistory?.displayPaidDates | date : 'MMM d, y' }}
                      </ng-container>
                      <ng-template #invoicedDate>
                        {{ vehicleHistory?.invoiceDate | date : 'MMM d, y' }}
                      </ng-template>
                    </ng-container>
                  </span>

                  <span class="ro-created-date" *ngIf="vehicleHistory?.orderStatus !== 'invoice'">Estimate</span>
                </div>
              </div>
            </div>
          </div>
        </p-header>

        <!-- Follow-up empty screen -->
        <div class="accordian-empty-screen" *ngIf="false">There are no upcoming follow-ups for this vehicle</div>

        <!-- Follow-up list -->
        <div class="vehicle-history-accordian-content" *ngIf="!vehicleHistory?.historyOrder">
          <div class="vehicle-history-notes-wrapper">
            <div class="row">
              <div class="col-md-4">
                <h5>Shop notes</h5>
                <p class="one-line-elipsis" [ngClass]="{ 'remove-elipsis': isDetailExpanded?.shopNotes }">
                  {{ vehicleHistory?.shopNotes || '' }}
                </p>

                <span *ngIf="shopNotesLength > 6" class="showmore-vehicle" (click)="isDetailedNotes('shopNotes')">
                  <span *ngIf="!isDetailExpanded?.shopNotes">Show more</span>
                  <span *ngIf="isDetailExpanded?.shopNotes">Show less</span>
                </span>
              </div>

              <div class="col-md-4">
                <h5>Customer recommendations</h5>
                <p class="one-line-elipsis" [ngClass]="{ 'remove-elipsis': isDetailExpanded?.customerNotes }">
                  {{ vehicleHistory?.customerNotes || '' }}
                </p>

                <span *ngIf="customerNotesLength > 6" class="showmore-vehicle"
                  (click)="isDetailedNotes('customerNotes')">
                  <span *ngIf="!isDetailExpanded?.customerNotes"> Show more</span>
                  <span *ngIf="isDetailExpanded?.customerNotes">Show less</span>
                </span>
              </div>

              <div class="col-md-4">
                <h5>Service writer:</h5>
                <p>{{ vehicleHistory?.serviceWriter?.name }}</p>
              </div>
            </div>
          </div>

          <!-- Vehicle history services -->
          <div class="vehicle-history-header">
            <div class="vehicle-history-header-left">
              <div class="vehicle-history-header-icon">
                <i class="far fa-tools"></i>
              </div>

              <div class="vehicle-history-header-content">
                Services
                <div class="repair-order-count-bubble">
                  {{ services.length || 0 }}
                </div>
              </div>
            </div>

            <div class="vehicle-history-header-right">
              <div class="open-in-ro pointer" (click)="openServiceInRO(vehicleHistory?.estimateId, $event)">Open
                services in RO</div>
            </div>
          </div>

          <div class="vehicle-history-body" *ngFor="let service of services; let serviceIndex = index">
            <div class="vehicle-history-body-content">
              <div class="vehicle-history-service-row">
                <div class="vehicle-history-service-col">
                  <div class="vehicle-history-service">
                    <div class="vehicle-history-service-icon">
                      <i class="fal fa-tools"></i>
                    </div>

                    <div class="vehicle-history-service-content one-line-elipsis" tooltipPosition="top"
                      [pTooltip]="service.title" [innerHTML]="service?.title | highlight : searchQuery"
                      (click)="openServiceInRO(vehicleHistory?.estimateId, $event)"></div>
                  </div>
                </div>

                <div class="vehicle-history-service-col">
                  <div class="vehicle-history-inspection-wrapper">
                    <div class="pr-3" style="width: 159px">
                      <span
                        class="font-11 badge badge-pill badge-authorized {{ serviceStatusBadge[service.serviceStatus]?.class }}">
                        {{ serviceStatusBadge[service.serviceStatus]?.name }}
                      </span>
                    </div>

                    <div class="vehicle-history-inspection-content one-line-elipsis pointer"
                      (click)="openInspectionInRO(vehicleHistory?.estimateId, service?.inspection?.inspectionId, service?.serviceId)">
                      <i class="fal fa-ballot-check pr-1" *ngIf="service?.inspection"></i>

                      <span *ngIf="service?.inspection" tooltipPosition="top" [pTooltip]="service?.inspection?.title">
                        {{ service?.inspection?.title }}
                      </span>
                    </div>

                    <div class="vehicle-history-inspection-amount">
                      <p>{{ service?.serviceTotal?.total | currency : usd }}</p>
                    </div>

                    <div class="vehicle-history-technician">
                      <ul class="technician-bubble-list">
                        <li class="bubble-list-item active" *ngIf="service?.tech?.techId">
                          <span>{{ service?.tech?.initials }}</span>
                        </li>

                        <li class="bubble-list-item" *ngIf="service?.hTechOne?.techId">
                          <span>
                            {{ service?.hTechOne?.initials }}
                          </span>
                        </li>

                        <li class="bubble-list-item" *ngIf="service?.hTechTwo?.techId">
                          <span>
                            {{ service?.hTechTwo?.initials }}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Vehicle history services footer-->
          <div class="vehicle-history-footer mt-4">
            <div class="vehicle-history-footer-left">
              <div class="vehicle-history-footer-icon">
                <i class="far fa-paperclip"></i>
              </div>

              <div class="vehicle-history-footer-content">
                Attachments
                <div class="repair-order-count-bubble">
                  {{ vehicleHistory.attachmentCount || 0 }}
                </div>
              </div>
            </div>

            <div class="vehicle-history-footer-middle">
              <ul class="attachment-list">
                <li class="attachment-list-item">
                  <i class="fal fa-file-audio"></i><span>{{ audioCount }} Audio</span>
                </li>

                <li class="attachment-list-item">
                  <i class="fal fa-file-pdf"></i><span>{{ pdfCount }} PDF</span>
                </li>

                <li class="attachment-list-item">
                  <i class="fal fa-file-image"></i><span>{{ imageCount }} Image</span>
                </li>

                <li class="attachment-list-item">
                  <i class="fal fa-file"></i><span>{{ otherCount }} Others</span>
                </li>
              </ul>
            </div>

            <div class="vehicle-history-footer-right">
              <div class="open-in-ro pointer" (click)="openAttachmentInRO(vehicleHistory?.estimateId)">Open attachments
                in RO</div>
            </div>
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>
</div>
